module.exports = __webpack_public_path__ + "./assets/img/clients_1.7c35c150.png";